module.exports = __webpack_public_path__ + "mo/img/swiper_bg06.85334268.png";